goog.provide('el8.ptdata.model.note.base');

goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.ptdata.model.attachment');
goog.require('el8.ptdata.model.note.asSoyMap');

// -------------------
// ** BASE NOTE **
// Needs to be global to be accessible
// to both visit note and nonvisite note 
// constructors
// -------------------
el8.ptdata.model.note.base = function(spec) {
    this.populate(spec);
};
el8.ptdata.model.note.base.inheritsFrom(el8_Entity);
el8.ptdata.model.note.base.prototype.populate = function(spec) {
    spec = spec || {};
    if (spec.type) { spec.noteTypeId = spec.type.id; }

    if (spec.doc_tags) {
        el8.data.docTags.create(spec.doc_tags, true);
        this.setDocTagIds(_.pluck(spec.doc_tags, 'id'));
    }

    el8_Entity.prototype.populate.call(this, spec);
};

el8.ptdata.model.note.base.makeDocument();
el8.ptdata.model.note.base.makeHoldable();
el8.ptdata.model.note.base.addDateTime("createDate", false, el8.service.tz.now());

// is this a note we imported from another practice?
el8.ptdata.model.note.base.addIntProperty("documentSubType", false, null);
el8.ptdata.model.note.base.addBoolean("importedNote");
// client-only var used when rendering an imported note in the report feed
el8.ptdata.model.note.base.addBoolean('imagesLoaded');

el8.ptdata.model.note.base.addIntProperty("noteTypeId", true);
el8.ptdata.model.note.base.addStringProperty("followUp", true);
el8.ptdata.model.note.base.addProperty("images", true, []);
el8.ptdata.model.note.base.addProperty("imageIds", false, []);
el8.ptdata.model.note.base.addProperty("fullSizeImages", false, []);
el8.ptdata.model.note.base.addStringProperty('imageAsPdfUrl');
el8.ptdata.model.note.base.addBoolean('allImagesImported');
el8.ptdata.model.note.base.addProperty('importedFiles', false, []);

el8.ptdata.model.note.base.addModelSetProperty("attachments", el8.ptdata.model.attachment, false, []);

el8.ptdata.model.note.base.addDocTags();

// Notes have a big, custom-defined asSoyMap fn
el8.ptdata.model.note.base.prototype.asSoyMap = function() {
    return el8.ptdata.model.note.asSoyMap(this);
};

// -----------------------------
// Useful methods
// -----------------------------
el8.ptdata.model.note.base.prototype.isSaved = function() { return this.getSignDate() ? true : false; };

